import { documentHasElements } from "modules/dom";
import "./legacy-block.scss";

documentHasElements(".js-legacy-block", (LagacyBlocks) => {
    LagacyBlocks.forEach((lagacyBlock) => {

        const scrollDetector = lagacyBlock.querySelector<HTMLElement>(".scroll-detector");
        const cardsHeader = lagacyBlock.querySelectorAll<HTMLHeadingElement>(".cards > div h3");
        const cardsParagraph = lagacyBlock.querySelectorAll<HTMLParagraphElement>(".cards > div p");

        const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    cardsHeader.forEach((h3: HTMLHeadingElement) => {
                        h3.classList.add("scrolled");
                    });

                    setTimeout(() => {
                        cardsParagraph.forEach((p: HTMLParagraphElement) => {
                            p.classList.add("scrolled");
                        });
                    }, 600);
                }
            });
        });

        if (scrollDetector) {
            observer.observe(scrollDetector);
        }
                
    });
});